angular.module("ainapp")
    .controller("POSSalesDetailReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "POS Detail Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.Init = function () {

                var startdate = new Date(new Date().getFullYear(), 0, 1);

                $scope.filter = {
                    FromDate: startdate,
                    ToDate: new Date(),
                    BranchId: "",
                    Keyword: "",

                }
            }
            $scope.Init();






            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;

                        o.data.FromDate = $scope.filter.FromDate;
                        o.data.ToDate = $scope.filter.ToDate;
                        o.data.BranchId = $scope.filter.BranchId;

                        o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                        o.data.FromDay = $scope.filter.FromDate.getDate();
                        o.data.FromYear = $scope.filter.FromDate.getFullYear();

                        o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                        o.data.ToDay = $scope.filter.ToDate.getDate();
                        o.data.ToYear = $scope.filter.ToDate.getFullYear();

                        MainService.CounterSalesDetailsInReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "CounterSale.Date": {
                                type: "date",
                            },

                            "CounterSale.BillNo": {
                                type: "string",
                            },

                            "CounterSale.PayType": {
                                type: "string",
                            },

                            "CounterSale.AccountMaster.Name": {
                                type: "string",
                            },
                            "CounterSale.User.UserName": {
                                type: "string",
                            },
                            "CounterSale.IsPaymentDone": {
                                type: "string",
                            },

                            "VAT.Name": {
                                type: "boolean",
                            },
                            Price: {
                                type: "number",
                            },
                            Quantity: {
                                type: "number",
                            },
                            Gross: {
                                type: "number",
                            },
                            Discount: {
                                type: "number",
                            },
                            Taxable: {
                                type: "number",
                            },
                            TotalVAT: {
                                type: "number",
                            },
                            GrandTotal: {
                                type: "number",
                            },
                            "VAT.Name": {
                                type: "string",
                            },
                            "Product.Name": {
                                type: "string",
                            },
                            "CounterSale.Employee.Name": {
                                type: "string",
                            },
                            "CounterSale.Warehouse.Name": {
                                type: "string",
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                aggregate: [{
                        field: "Quantity",
                        aggregate: "sum"
                    },
                    {
                        field: "Gross",
                        aggregate: "sum"
                        }, {
                        field: "Discount",
                        aggregate: "sum"
                        },
                    {
                        field: "Taxable",
                        aggregate: "sum"
                        },
                    {
                        field: "TotalVAT",
                        aggregate: "sum"
                        },
                    {
                        field: "GrandTotal",
                        aggregate: "sum"
                        }],
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "CounterSale.BillNo",
                        title: "Bill No",
                                            },
                    {
                        field: "CounterSale.AccountMaster.Name",
                        title: "Customer",
                                            },
                    {
                        field: "CounterSale.User.UserName",
                        title: "Created By",
                                            },
                    {
                        field: "CounterSale.Date",
                        template: "#= kendo.toString(kendo.parseDate(CounterSale.Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                                            },
                    {
                        field: "CounterSale.PayType",
                        title: "Pay Type",
                                            },
                    {
                        field: "Product.Name",
                        title: "Product"
                    },
                    {
                        field: "Quantity",
                        title: "Quantity",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                                            },
                    {
                        field: "Price",
                        title: "Price",
                                            },
                    {
                        field: "Gross",
                        title: "Gross",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                                            },
                    {
                        field: "Discount",
                        title: "Discount",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                                            }, {
                        field: "Taxable",
                        title: "Taxable",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                                            },
                    {
                        field: "TotalVAT",
                        title: "TotalVAT",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                                            },
                    {
                        field: "VAT.Name",
                        title: "VAT"
                    },
                    {
                        field: "GrandTotal",
                        title: "Grand Total",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                    },

                    {
                        field: "CounterSale.IsPaymentDone",
                        title: "Payment Done?",
                        template: "<p ng-if='dataItem.CounterSale.IsPaymentDone'>Yes</p> <p ng-if='!dataItem.CounterSale.IsPaymentDone'>No</p>"
                                            },

                    {
                        field: "CounterSale.Employee.Name",
                        title: "Employee",
                                            }, {
                        field: "CounterSale.Warehouse.Name",
                        title: "Warehouse",
                                            },

                    ],
            };

            $scope.filterData = function () {
                console.log($scope.filter)
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refreshData = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }



        }])
